import { apiGet, apiPost, apiPut, apiDelete } from "../../api/client";
import { ILocation } from "../../types";

/**
 * REST client for stored customer locations (served under
 * `/api/location/saved`). Replaces direct Firestore access so location data is
 * read and written exclusively through the API.
 */

const LOCATION_PATH = "/api/location/saved";

/** Serialized location payload sent as a JSON request body (e.g. `Location.data()`). */
type LocationPayload = Record<string, unknown>;

/** Full location list for a workspace (no pagination — current default). */
export const listLocations = async (
  token: string,
  workspaceId: string,
): Promise<ILocation[]> => {
  const envelope = await apiGet(token, LOCATION_PATH, workspaceId);
  return (envelope?.data as ILocation[]) ?? [];
};

export const createLocation = async (
  token: string,
  workspaceId: string,
  location: LocationPayload,
): Promise<ILocation> => {
  const envelope = await apiPost(token, LOCATION_PATH, location, workspaceId);
  return envelope?.data as ILocation;
};

export const updateLocation = async (
  token: string,
  workspaceId: string,
  locationId: string,
  location: LocationPayload,
): Promise<ILocation> => {
  const envelope = await apiPut(
    token,
    `${LOCATION_PATH}/${locationId}`,
    location,
    workspaceId,
  );
  return envelope?.data as ILocation;
};

export const deleteLocation = async (
  token: string,
  workspaceId: string,
  locationId: string,
): Promise<void> => {
  await apiDelete(token, `${LOCATION_PATH}/${locationId}`, workspaceId);
};
